/**
 * Created by Julio Perez on 5/24/2016.
 */
routes.$inject = ['$stateProvider'];
export default function routes($stateProvider){

    $stateProvider
        .state('appView', {
            url: '/',
            template: require('./index.html')
        })
        // .state('appView.contentSection', {
        //     url:':section',
        //     resolve: {
        //         navLinksStripService: 'navLinksStripService',
        //         sectionContentService: 'sectionContentService',
        //         section: ['$stateParams', function($stateParams){
        //             return $stateParams.section;
        //         }]
        //     },
        //     views: {
        //         "content-section@appView":{
        //             template: require('../views/section-content/index.html')
        //         }
        //     }
        // })

}





// WEBPACK FOOTER //
// ./src/app/app-view/app-view.routes.js